module.exports = new __parcel__URL__("click.92e05379.mp3").toString();